module.exports = __webpack_public_path__ + "img/movies.a3cb5226.svg";